export type ServerEnvironment = 'PRODUCTION' | 'QA' | 'DEVELOPMENT'

export const allServerEnvironments: ServerEnvironment[] = [
  'DEVELOPMENT',
  'QA',
  'PRODUCTION'
]

export const serverEnvI18n: Record<ServerEnvironment, string> = {
  PRODUCTION: 'title_serverEnvironmentProduction',
  QA: 'title_serverEnvironmentQualityAssurance',
  DEVELOPMENT: 'title_serverEnvironmentDevelopment'
}
